module.exports = __webpack_public_path__ + "static/media/github.bb90575f.png";